// extracted by mini-css-extract-plugin
export default {"avatarcont":"Style_avatarcont__0OAAi","avatar":"Style_avatar__Zi8v1","avatar__image":"Style_avatar__image__vVoOe"};